import React, { useState } from 'react';
import { Colors, PrimaryButton, Text } from 'library';
import { InputAdornment, styled, TextField } from '@mui/material';
import { Place, Search, CheckCircleOutline, AccessTime, StarOutline } from '@mui/icons-material';
import { StaffFilterOptions, defaultFilters } from './StaffFilter';

export function HomeFindSection({
    zipCode,
    updateZipCode,
    onSearch,
}: {
    zipCode: string;
    updateZipCode: (event: React.ChangeEvent<HTMLInputElement>) => void;
    onSearch: (filters: StaffFilterOptions) => void;
}) {
    const [showHelperText, setShowHelperText] = useState(false);

    function search() {
        if (zipCode.length < 5) {
            setShowHelperText(true);
        } else {
            setShowHelperText(false);
            onSearch(defaultFilters);
        }
    }

    function enterPressHandler(e: React.KeyboardEvent<HTMLInputElement>) {
        if (e.key === 'Enter') {
            search();
        }
    }

    return (
        <>
            <Text variant="h1" bold textStyle={{ color: Colors.darkNavy, marginBottom: 6 }}>
                Find Staff
            </Text>
            <Text variant="body2" textStyle={{ color: Colors.mediumGrey, marginBottom: 8 }}>
                Enter your zip code to see available substitutes nearby.
            </Text>
            <TextField
                variant="outlined"
                InputProps={{
                    startAdornment: (
                        <InputAdornment position="start">
                            <Place style={{ color: Colors.darkNavy }} />
                        </InputAdornment>
                    ),
                    style: { fontFamily: 'Outfit', color: Colors.darkNavy, borderRadius: 12, marginTop: 12 },
                }}
                style={{ width: '100%' }}
                placeholder="Zip Code"
                value={zipCode}
                onChange={updateZipCode}
                onKeyUp={enterPressHandler}
                helperText={showHelperText ? 'Please enter a valid zip code' : null}
                FormHelperTextProps={{ style: { fontFamily: 'Outfit', color: Colors.error } }}
                maxRows={1}
            />
            <PrimaryButton
                buttonStyle={{ width: '100%', marginTop: 16, height: 52, borderRadius: 100 }}
                onClick={search}
            >
                <Search style={{ marginRight: 8, fontSize: 20 }} />
                Search Available Staff
            </PrimaryButton>
            <TrustGrid>
                <TrustBadge icon={<CheckCircleOutline style={trustIconStyle} />} text="Background checked & compliant" />
                <TrustBadge icon={<CheckCircleOutline style={trustIconStyle} />} text="State-licensed credentials verified" />
                <TrustBadge icon={<AccessTime style={trustIconStyle} />} text="Available for same-day coverage" />
                <TrustBadge icon={<StarOutline style={trustIconStyle} />} text="Rated by centers like yours" />
            </TrustGrid>
        </>
    );
}

function TrustBadge({ icon, text }: { icon: React.ReactNode; text: string }) {
    return (
        <TrustItem>
            {icon}
            <Text variant="caption" textStyle={{ color: Colors.darkGrey }}>{text}</Text>
        </TrustItem>
    );
}

const trustIconStyle = { fontSize: 18, color: Colors.turquoise };

const TrustGrid = styled('div')({
    display: 'grid',
    gridTemplateColumns: '1fr 1fr',
    gap: '10px 16px',
    marginTop: 20,
});

const TrustItem = styled('div')({
    display: 'flex',
    alignItems: 'center',
    gap: 6,
});
